// extracted by mini-css-extract-plugin
module.exports = {"link":"BackLink_link__PXHYo","icon":"BackLink_icon__l14aD"};